import React, { lazy, Suspense, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
const AddTechCardModal = lazy(() =>
  import("src/features/Modal").then((modal) => ({
    default: modal.AddTechCardModal,
  }))
);

export default function AddTechCardButton() {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <Button
        style={{ marginBottom: 15 }}
        icon={<PlusOutlined />}
        type="primary"
        onClick={() => setOpen(true)}
      >
        Добавить тех. карту
      </Button>
      {isOpen ? (
        <Suspense fallback={<div></div>}>
          <AddTechCardModal isOpen={isOpen} setOpen={setOpen} />
        </Suspense>
      ) : null}
    </>
  );
}
